/**
 * @what set the default route (should be /oops/) and ?
 * @why make sure that if there are any issues with routing to the wrong place we can provide meaningful messages
 */
angular.module('utility-ng-configuration').provider('ConsistentPageConfiguration', function () {

  var DEFAULTS = {
    pageName: undefined,
    pageClassName: undefined,
    previousRoute: undefined,
    classPrefix: 'view'
  };

  var configuration = _.merge({}, DEFAULTS);

  var configure = this.configure = function configure_ConsistentPageConfiguration(userConfig) {

    if (!!userConfig) {
      configuration = _.merge({}, DEFAULTS, userConfig);
    }

    return configuration;
  };

  this.activate = function activate_ConsistentPageConfiguration() {
    throw new EABError('utility-ng-configuration', 101);
  };

  this.$get = function ($rootScope, $state) {
    return {
      configure: function configuration_ConsistentPageConfiguration(userConfig) {
        return configure(userConfig);
      },
      activate: function activate_ConsistentPageConfiguration(userConfig) {

        $state.__previousRoutes__ = [];
        $state.__shouldSavePreviousRoute__ = true;
        $state.__goToPrevious__ = function __goToPrevious__ConsistentPageConfiguration () {
          var lastState = $state.__previousRoutes__.pop();
          $state.__shouldSavePreviousRoute__ = false;
          return $state.go(lastState.state.name, lastState.params);
        };

        if (!!userConfig) {
          this.configure(userConfig);
        }

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, error) {

          configuration.pageClassName = configuration.classPrefix + '-' + toState.name.toLowerCase().replace(/\./g, '-');
          configuration.pageName = (!!toState.data && _.size(toState.data.viewTitle) > 0)
            ? toState.data.viewTitle
            : _.reduce(toState.name.toLowerCase().replace(/-/g, ' ').replace(/\./g, ' ').split(' '), function (S, str) {
            return S + _.capitalize(str) + ' ';
          }, '');

          configuration.previousRoute = {
            state: fromState,
            params: fromParams
          };

          $rootScope.__pageName__ = configuration.pageName;
          if ($state.__shouldSavePreviousRoute__) {
            $state.__previousRoute__ = configuration.previousRoute;
            $state.__previousRoutes__.push(configuration.previousRoute);
          }
          $state.__shouldSavePreviousRoute__ = true;
          angular.element('body')
            .attr('class', configuration.classPrefix)
            .addClass(configuration.pageClassName);

        });

      }
    };
  };

});



// WEBPACK FOOTER //
// consistent_page_configuration.js